import { api } from "../../api";
import { Select, TextArea, TextInput } from "../../components/form";
import { SpecializedControl } from "../../components/specializedObject";
import { Paragraph } from "../../components/text";
import { displayFormControl } from "../../ui/alert";
import { runOperation } from "../../ui/operation";

export function showNewChatSessionDialog(chatClientId, onCreated) {
    displayFormControl({
        title: "New chat session",
        message: Paragraph("Create a session with an optional tag, expiration and additional model context."),
        dialogSize: "large",
        formControlItem: SpecializedControl({
            value: {
                expires: 3600
            },
            fields: [
                {
                    name: "tag",
                    label: "Tag",
                    control: TextInput(null, "abc123...")
                },
                {
                    name: "expires",
                    label: "Expiration",
                    control: Select({
                        value: 3600,
                        items: [
                            { value: 600, label: "10m" },
                            { value: 3600, label: "1h" },
                            { value: 21600, label: "6h" },
                            { value: 86400, label: "1d" },
                            { value: 604800, label: "7d" },
                            { value: 2592000, label: "30d" }
                        ]
                    })
                },
                {
                    name: "extraContext",
                    label: "Context",
                    control: TextArea(null, "")
                }
            ]
        }),
        onConfirm(value) {
            const expires = Number(value.expires);

            runOperation("Saving chat session...", async () => {
                await api.postJson(`/api/v1/web-chat-client/${chatClientId}/sessions`, {
                    tag: value.tag,
                    expires,
                    extraContext: value.extraContext
                });
                await onCreated?.();
            });
        },
        validate: [
            [x => Number(x.expires) >= 600, "The duration must be greater than or equal to 10 minutes."],
            [x => Number(x.expires) <= 7776000, "The duration must be less than or equal to 90 days."],
            [x => (x.extraContext || "").length <= 4096, "The context must have a maximum of 4,096 characters."]
        ]
    });
}
